import PollCard from './PollCard';
export default PollCard;
